// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d59a3f46","851":"ee36c5b5"}[chunkId] + ".chunk.js";
};